import React, { ElementType, forwardRef } from "react";
import classNames from "classnames";
import { TagComponent, TagProps } from "./types";
import { GenericRef } from "@ramsey-design-system/common/types";

const Tag = <C extends ElementType = "a">(
  {
    children,
    className,
    color = "neutral",
    element,
    icon: TagIcon,
    isOnDarkCanvas = false,
    size = "medium",
    subtle = false,
    ...rest
  }: TagProps<C>,
  ref: GenericRef<C>
) => {
  const Element = element || (rest.href ? "a" : "span");
  const tagClasses = classNames(
    "rds-Tag",
    {
      [`rds-Tag--${color}`]: color !== "neutral",
      [`rds-Tag--${size}`]: size !== "md",
      "rds-Tag--subtle": subtle,
      "on-darkCanvas": isOnDarkCanvas,
    },
    className
  );

  return (
    <Element className={tagClasses} {...rest} ref={ref}>
      {TagIcon && (
        <TagIcon
          fill="currentColor"
          className="rds-Tag-icon"
          aria-hidden
          focusable={false}
        />
      )}

      {children}
    </Element>
  );
};

const Component = forwardRef(Tag);
Component.displayName = "Tag";

export default Component as TagComponent;
